import React from 'react'
import styled from 'styled-components'
import { InputStyle, InputVariant } from './input'
import { fontSizes, colors } from '../../../styles/theme'
import { DateRangePicker, DateRangePickerShape } from 'react-dates'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'

const StyledDateRangePicker = styled.div`
  .DateRangePicker_picker {
    z-index: 100;
  }

  .DateRangePickerInput {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;

    input {
      font-weight: normal;
    }

    ${InputStyle}
  }

  .DateInput {
    width: auto;
    background: transparent;

    input {
      font-size: ${fontSizes.size500};
      background: transparent;
    }
  }

  .DayPickerKeyboardShortcuts_panel {
    .DayPickerKeyboardShortcuts_title {
      color: ${props => props.theme.colors.typography.dark.text};
    }

    color: ${props => props.theme.colors.typography.dark.subtext};
  }

  .DateInput_input__focused {
    border-bottom-color: ${colors.primary500};
  }

  .DayPickerKeyboardShortcuts_show__topRight::before {
    border-right-color: ${colors.primary500};
  }

  .CalendarDay__selected {
    background: ${colors.primary500};
    border-color: ${colors.primary600};
  }

  .CalendarDay__selected:hover {
    background: ${colors.primary600};
    border-color: ${colors.primary700};
  }

  .CalendarDay__selected_span,
  .CalendarDay__hovered_span:hover,
  .CalendarDay__hovered_span {
    color: ${colors.neutral100};
    background: ${colors.primary200};
    border-color: ${colors.primary300};
  }

  .DayPickerKeyboardShortcuts_show__bottomRight::before {
    border-right-color: ${colors.primary400};
  }
`

const DateRange = ({
  variant,
  ...props
}: { variant?: InputVariant } & DateRangePickerShape): JSX.Element => {
  return (
    <>
      {/*
        // @ts-ignore */}
      <StyledDateRangePicker variant={variant}>
        <DateRangePicker block={true} {...props} />
      </StyledDateRangePicker>
    </>
  )
}

export default DateRange
